import { api } from "@/lib/api";
import type { ApiResponse } from "@learn-me/types";

export interface Badge {
  id: string;
  name: string;
  description: string;
  icon: string | null;
  trigger: string;
  course: {
    id: string;
    title: string;
    slug: string;
  };
  earned: boolean;
  earnedAt: string | null;
}

export interface EarnedBadge {
  id: string;
  name: string;
  description: string;
  icon: string | null;
  trigger: string;
  course: {
    id: string;
    title: string;
    slug: string;
  };
  earnedAt: string;
}

export interface Milestone {
  id: string;
  title: string;
  description: string;
  chapterPosition: number;
  reached: boolean;
}

export interface GamificationSummary {
  totalBadges: number;
  earnedBadges: number;
  progress: number;
  recentBadges: {
    id: string;
    name: string;
    icon: string | null;
    earnedAt: string;
  }[];
}

export interface NewBadge {
  badgeId: string;
  name: string;
  icon: string;
}

export const gamificationApi = {
  // Obtener todos los badges (con estado earned)
  getBadges: async (courseId?: string): Promise<Badge[]> => {
    const params = courseId ? `?courseId=${courseId}` : "";
    const response = await api.get<ApiResponse<Badge[]>>(
      `/gamification/badges${params}`,
    );
    return response.data.data ?? [];
  },

  // Obtener solo badges ganados
  getEarnedBadges: async (): Promise<EarnedBadge[]> => {
    const response = await api.get<ApiResponse<EarnedBadge[]>>(
      "/gamification/badges/earned",
    );
    return response.data.data ?? [];
  },

  // Obtener milestones de un curso
  getCourseMilestones: async (courseId: string): Promise<Milestone[]> => {
    const response = await api.get<ApiResponse<Milestone[]>>(
      `/gamification/courses/${courseId}/milestones`,
    );
    return response.data.data ?? [];
  },

  // Obtener resumen para dashboard
  getSummary: async (): Promise<GamificationSummary> => {
    const response = await api.get<ApiResponse<GamificationSummary>>(
      "/gamification/summary",
    );
    return (
      response.data.data ?? {
        totalBadges: 0,
        earnedBadges: 0,
        progress: 0,
        recentBadges: [],
      }
    );
  },
};
